"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.I18N_RETURNS_HEADINGS = exports.defaultAddress = void 0;
exports.defaultAddress = {
    city: '',
    countryCode: 'DE',
    lines: [],
    streetAddress: '',
    zip: '',
};
exports.I18N_RETURNS_HEADINGS = {
    accountNumber: 'DHL Billing Number',
    customerFirstNames: 'Customer First Name (s)',
    customerLastName: 'Customer Last Name',
    customerPublicId: 'Customer Public ID',
    dateOfReceival: 'Date of Receival',
    documentId: 'Document ID',
    documentIds: 'Document IDs',
    index: 'Index',
    packageWeight: 'Weight',
    productAndServiceIdentification: 'DHL Product and Service ID',
    recipientCity: 'Recipient City',
    recipientCountry: 'Recipient Country',
    recipientEmail: 'Recipient Email',
    recipientName1: 'Recipient Name 1',
    recipientNameAndPostBox: 'Recipient Name 2 / Postbox',
    recipientPhone: 'Recipient Phone',
    recipientPostCode: 'Recipient Postcode',
    recipientPublicID: 'Recipient Public ID',
    recipientReference: 'Recipient Reference',
    recipientStreetAndHouseNumber: 'Recipient Street and House Number',
    requestedAt: 'Requested at',
    returnType: 'Return type',
    senderCity: 'Sender City',
    senderCountry: 'Sender Country',
    senderCurrent: 'Sender Current',
    senderName1: 'Sender Name 1',
    senderPostCode: 'Sender Postcode',
    senderReference: 'Sender Reference',
    senderStreetAndHouseNumber: 'Sender Street and House Number',
    sendingDate: 'Sending Date',
    stackNumber: 'Stack #',
    subjectCurrent: 'Subject Current',
};
//# sourceMappingURL=constants.js.map